<template>
  <asd20-list
    headline="Open Seats by Grade"
    multi-column>
    <asd20-list-item
      v-for="(seat, index) in seatsByGrade"
      :key="index"
      :label="seat.gradeName"
      condensed>
      <asd20-progress
        :segments="segments"
        :max="seat.capacity"
        :value="seat.capacity - seat.available"
        show-percentage
      />
    </asd20-list-item>
  </asd20-list>
</template>

<script>
import Asd20List from '@asd20/ui/src/components/organisms/Asd20List'
import Asd20ListItem from '@asd20/ui/src/components/molecules/Asd20ListItem'
import Asd20Progress from '@asd20/ui/src/components/molecules/Asd20Progress'

export default {
  name: 'Asd20OpenSeats',
  components: {
    Asd20List,
    Asd20ListItem,
    Asd20Progress
  },
  props: {
    seats:{
      type: Array, default: null
    }
  },
  data: () => {
    return  {
      segments: [
        {
          label: 'Seats Available',
          threshold: 0.0,
          background: 'hsla(130, 80%, 70%, 1)',
        },
        {
          label: 'Filling Up',
          threshold: 0.75,
          background: 'hsla(50, 80%, 70%, 1)',
        },
        {
          label: 'Full',
          threshold: 0.9,
          background: 'hsla(10, 70%, 60%, 1)',
        },
      ]
    }
  },
  computed:{
    seatsByGrade() {
      const numberLabels = {'p': 'Preschool', 'k': 'kindergarted', '1': 'First', '2': 'Second', '3': 'Third', '4':'Fourth', '5':'Fifth', '6':'Sixth', '7': 'Seventh', '8':'Eighth', '9':'Ninth', '10': 'Tenth', '11': 'Eleventh', '12': 'Twelfth'}
      if(!this.seats) return
      return this.seats.map(g => ({
        ...g,
        available: g.capacity - g.reserved - g.occupied,
        gradeName: `${numberLabels[g.grade]} grade`
        }
      ))
    },
  }
}
</script>
